import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

function UsersPanel() {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const getUsers = async () => {
      try {
        setLoading(true)

        const res = await fetch(`${process.env.REACT_APP_API_URL}/users`, {
          credentials: "include",
        })

        if (!res.ok) throw new Error("Failed to fetch")

        const data = await res.json()
        setUsers(Array.isArray(data) ? data : [])
      } catch (err) {
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    getUsers()
  }, [])

  if (loading) {
    return <div className="text-center mt-4">Loading users...</div>
  }

  return (
    <div className="UsersPanel col-12 d-flex flex-column align-items-center">
      <div className="col-12 text-start ms-3">
        {/* Header */}
        <div className="col-12 border-bottom">
          <div className="d-flex justify-content-center">
            <div className="col-10 d-flex fw-bold pb-2">
              <div className="col-3">Username</div>
              <div className="col-3">Email</div>
              <div className="col-2">Role</div>
              <div className="col-2">Verified</div>
              <div className="col-2">Created</div>
            </div>
          </div>
        </div>

        {/* Empty State */}
        {users.length === 0 && (
          <div className="text-center py-4 text-muted">No users found</div>
        )}

        {/* Rows */}
        {users.map((user) => (
          <div
            key={user._id}
            onClick={() => navigate(`/users/${user._id}`)}
            className="col-12 d-flex justify-content-center border-bottom py-2 user-row"
            style={{ cursor: "pointer" }}
          >
            <div className="col-10 d-flex align-items-center">
              <div style={{ flex: 3 }} className="px-2">
                {user.username}
              </div>

              <div style={{ flex: 3 }} className="px-2">
                {user.email}
              </div>

              <div style={{ flex: 2 }} className="px-2">
                {user.account_type}
              </div>

              <div style={{ flex: 2 }} className="px-2">
                {user.email_verified ? "Yes" : "No"}
              </div>

              <div style={{ flex: 2 }} className="px-2">
                {user.createdAt
                  ? new Date(user.createdAt).toLocaleDateString()
                  : "—"}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default UsersPanel
